'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 500;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.25);\n'], ['\n  position: fixed;\n  z-index: 500;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.25);\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  color: #fff;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  color: #fff;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n'], ['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  background-color: black;\n'], ['\n  position: relative;\n  background-color: black;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactResizeDetector = require('react-resize-detector');

var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Dialog = _styledComponents2.default.div(_templateObject2);

var CloseButton = _styledComponents2.default.div(_templateObject3);

var BlackBox = _styledComponents2.default.div(_templateObject4);

var Spinner = _styledComponents2.default.div(_templateObject5);

/** @class WelcomeVideo
  * Autoplays a welcome video when the user visits the lobby.
  * @param {url} video - the video to play
  */

var WelcomeVideo = function (_Component) {
  _inherits(WelcomeVideo, _Component);

  /** @constructor
    * Constructs a new instance of WelcomeVideo
    */
  function WelcomeVideo(props) {
    _classCallCheck(this, WelcomeVideo);

    var _this = _possibleConstructorReturn(this, (WelcomeVideo.__proto__ || Object.getPrototypeOf(WelcomeVideo)).call(this, props));

    _this.state = {
      showVideo: false,
      width: 640,
      height: 360
    };
    _this.handleStart = _this.handleStart.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.exit = _this.exit.bind(_this);
    return _this;
  }

  _createClass(WelcomeVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.welcomeVideos) window.vexpo.welcomeVideos = {};
      // is there a video to play?
      if (!this.props.video) return;
      // has it already played for this user on this login?
      if (window.vexpo.welcomeVideos[this.props.identifier]) {
        // if so, skip playing
        this.setState({ showVideo: false });
      } else {
        // otherwise, show the video
        this.setState({ showVideo: true });
        window.vexpo.welcomeVideos[this.props.identifier] = true;
      }
      /*
      // has it already played for this user?
      if(window.vexpo && window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
        const uid = window.vexpo.firebase.auth().currentUser.uid;
        var ref = window.vexpo.firebase.database().ref(`/welcomeVideo/${uid}/${this.props.identifier}`);
        ref.once('value', snapshot => {
          if(!snapshot.val()) {
            // Play the video
            this.setState({showVideo: true});
            // Save that we've played it
            ref.set(true);
          }
        })
      } else {
        // Always play if no user is logged in
        if(window.vexpo && window.vexpo.overlay) {
          this.setState({showVideo: true});
        }
      }*/
    }
  }, {
    key: 'handleStart',
    value: function handleStart() {
      if (window.vexpo && window.vexpo.sound) {
        window.vexpo.sound.shush();
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      this.setState({ showVideo: false }, function () {
        if (window.vexpo && window.vexpo.sound) {
          window.vexpo.sound.unshush();
        }
      });
    }
  }, {
    key: 'handleResize',
    value: function handleResize(newWidth) {
      var width = newWidth < 640 ? newWidth : 640;
      var height = width / 16 * 9;
      this.setState({ width: width, height: height });
    }

    /** @method render
      * Renders the video player
      */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.state.showVideo) return null;

      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, onResize: this.handleResize }),
        _react2.default.createElement(
          Dialog,
          null,
          _react2.default.createElement(
            CloseButton,
            { onClick: this.exit },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times-circle' })
          ),
          _react2.default.createElement(
            BlackBox,
            null,
            _react2.default.createElement(_reactPlayer2.default, { url: this.props.video, playing: true,
              width: this.state.width + 'px',
              height: this.state.height + 'px',
              onStart: this.handleStart,
              onEnded: function onEnded() {
                return _this2.exit();
              }
            })
          )
        )
      );
    }
  }]);

  return WelcomeVideo;
}(_react.Component);

exports.default = WelcomeVideo;


WelcomeVideo.propTypes = {
  identifier: _propTypes2.default.string,
  video: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/welcome-video/welcome-video.js
// module id = 232
// module chunks = 0